import { render, staticRenderFns } from "./lead-center-custom-group.renderer.vue?vue&type=template&id=3ce8b055&scoped=true&"
import script from "./lead-center-custom-group.renderer.vue?vue&type=script&lang=js&"
export * from "./lead-center-custom-group.renderer.vue?vue&type=script&lang=js&"
import style0 from "./lead-center-custom-group.renderer.vue?vue&type=style&index=0&id=3ce8b055&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce8b055",
  null
  
)

export default component.exports